const Onsite = ({ isActive = true }) => {
    return (
        <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.203125"
                width="25.6"
                height="25.6"
                rx="4.8"
                fill={isActive ? '#FFD6DA' : 'transparent'}
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.1954 6.77344H10.4053C10.0643 6.77344 9.74222 6.92998 9.53156 7.19808L7.41052 9.89759C7.19518 10.1717 7.07812 10.5101 7.07812 10.8586V11.4401C7.07812 12.39 7.61997 13.2134 8.41146 13.618V17.6623C8.41146 18.5214 9.1079 19.2179 9.96701 19.2179H16.6337C17.4928 19.2179 18.1892 18.5214 18.1892 17.6623V13.618C18.9807 13.2134 19.5226 12.39 19.5226 11.4401V11.0124C19.5226 10.5642 19.3721 10.1291 19.0952 9.77672L17.0691 7.19808C16.8585 6.92998 16.5364 6.77344 16.1954 6.77344ZM15.967 17.8845H16.6337C16.7564 17.8845 16.8559 17.7851 16.8559 17.6623V13.8845C16.1554 13.8845 15.5238 13.5899 15.0781 13.1179C14.6324 13.5899 14.0008 13.8845 13.3003 13.8845C12.5999 13.8845 11.9682 13.5899 11.5226 13.1179C11.0769 13.5899 10.4452 13.8845 9.74479 13.8845V17.6623C9.74479 17.7851 9.84428 17.8845 9.96701 17.8845H13.3003V15.6623C13.3003 15.1714 13.6983 14.7734 14.1892 14.7734H15.0781C15.569 14.7734 15.967 15.1714 15.967 15.6623V17.8845ZM9.74479 12.5512H9.52257C8.90892 12.5512 8.41146 12.0538 8.41146 11.4401V10.8586C8.41146 10.8089 8.42818 10.7605 8.45894 10.7214L10.5133 8.10677H16.0874L18.0468 10.6005C18.1391 10.7179 18.1892 10.863 18.1892 11.0124V11.4401C18.1892 12.0538 17.6918 12.5512 17.0781 12.5512H16.8559C16.2423 12.5512 15.7448 12.0538 15.7448 11.4401V10.9957C15.7448 10.6275 15.4463 10.329 15.0781 10.329C14.7099 10.329 14.4115 10.6275 14.4115 10.9957V11.4401C14.4115 12.0538 13.914 12.5512 13.3003 12.5512C12.6867 12.5512 12.1892 12.0538 12.1892 11.4401V10.9957C12.1892 10.6275 11.8908 10.329 11.5226 10.329C11.1544 10.329 10.8559 10.6275 10.8559 10.9957V11.4401C10.8559 12.0538 10.3584 12.5512 9.74479 12.5512Z"
                fill={isActive ? '#A82E3A' : '#616161'}
            />
        </svg>
    )
}

export default Onsite
